import React from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * CartPolicyNotice component
 * author: jaegeunlee
 * description
 */
const UnorderedList = styled.ul`
  ${Typography('body2.multiline').regular};
  color: ${({ theme }) => theme.color.gray600};
`
const ListItem = styled.li`
  position: relative;
  &:before {
    position: absolute;
    left: -12px;
    content: '•';
  }
  margin-left: 12px;
  margin-top: 8px;
  &:nth-of-type(1) {
    margin-top: 0;
  }
`

const CartPolicyNotice: React.FC = () => {
  return (
    <UnorderedList>
      <ListItem>
        장바구니에 담은 상품은 최대 30일간 보관되고 최대 20개까지 담을 수 있습니다.
      </ListItem>
      <ListItem>
        장바구니에서 수량 및 상세 옵션을 수정할 수 없는 상품도 있습니다. 삭제 후 다시 담아주세요.
      </ListItem>
      <ListItem>
        쿠폰 및 포인트가 적용된 최종 결제 금액은 다를 수 있으므로 예약화면에서 확인해 주세요.
      </ListItem>
    </UnorderedList>
  )
}

export default CartPolicyNotice
